import { PositionType } from 'data/types';
import { strokeToPolylinePoints } from 'utils/footprint-drawing-helpers';
import { FOOTPRINT_CANVAS_OFFSET } from 'utils/footprint-shapes-editing';

type DrawnSpacePreviewLayerProps = Readonly<{
  vertices: PositionType[];
}>;

export default function DrawnSpacePreviewLayer({
  vertices
}: DrawnSpacePreviewLayerProps) {
  if (vertices.length < 3) {
    return null;
  }

  return (
    <svg
      className='pointer-events-none absolute z-[40]'
      style={{
        left: `-${FOOTPRINT_CANVAS_OFFSET}px`,
        top: `-${FOOTPRINT_CANVAS_OFFSET}px`,
        width: `${FOOTPRINT_CANVAS_OFFSET * 2}px`,
        height: `${FOOTPRINT_CANVAS_OFFSET * 2}px`,
        overflow: 'visible'
      }}
    >
      <polygon
        points={strokeToPolylinePoints(vertices)}
        fill='rgba(18, 85, 139, 0.18)'
        stroke='#12558B'
        strokeWidth={3}
        strokeDasharray='8 5'
        strokeLinejoin='round'
      />
    </svg>
  );
}
